import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e059f426")

_pushScopeId("data-v-e059f426")
const _hoisted_1 = { class: "three-dots-menu" }
const _hoisted_2 = { class: "menu-card" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "hline" }, null, -1)
const _hoisted_4 = { class: "commands" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa = _resolveComponent("fa")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", {
      class: "dots",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.show && _ctx.show(...args)))
    }, [
      _createVNode(_component_fa, { icon: ['fas', 'ellipsis-h'] })
    ]),
    _withDirectives(_createVNode("div", {
      ref: "menuList",
      class: ["menu-list", { right: _ctx.isRight, left: !_ctx.isRight }],
      onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
      tabindex: "1"
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", null, [
          _createVNode("label", null, _toDisplayString(_ctx.title), 1)
        ]),
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
            return (_openBlock(), _createBlock("button", {
              key: i,
              onClick: ($event: any) => (_ctx.clickHook(item.clickAction))
            }, [
              _createVNode(_component_fa, {
                icon: item.icon
              }, null, 8, ["icon"]),
              _createVNode("span", null, _toDisplayString(item.name), 1)
            ], 8, ["onClick"]))
          }), 128))
        ])
      ])
    ], 34), [
      [_vShow, _ctx.isShow]
    ])
  ]))
})